// Frontend-Testdaten (Platzhalter) - werden später durch echte Daten ersetzt.

export const sperren = [
  {
    id: "TS-01",
    name: "Terrorsperre Haupttor",
    standort: "Zufahrt Nord",
    status: "geschlossen", // offen | geschlossen
    besetzung: "bemannt", // bemannt | unbemannt
    letzteAenderung: "2026-06-14 08:12",
    pos: { x: 22, y: 30 },
  },
  {
    id: "TS-02",
    name: "Terrorsperre Lieferzone",
    standort: "Zufahrt Ost",
    status: "offen",
    besetzung: "bemannt",
    letzteAenderung: "2026-06-14 08:47",
    pos: { x: 74, y: 26 },
  },
  {
    id: "TS-03",
    name: "Terrorsperre Parkhaus",
    standort: "Zufahrt Süd",
    status: "geschlossen",
    besetzung: "unbemannt",
    letzteAenderung: "2026-06-14 07:55",
    pos: { x: 40, y: 72 },
  },
  {
    id: "TS-04",
    name: "Terrorsperre Notausfahrt",
    standort: "Zufahrt West",
    status: "offen",
    besetzung: "unbemannt",
    letzteAenderung: "2026-06-14 06:30",
    pos: { x: 82, y: 68 },
  },
  {
    id: "TS-05",
    name: "Terrorsperre VIP-Einfahrt",
    standort: "Zufahrt Nord-Ost",
    status: "geschlossen",
    besetzung: "bemannt",
    letzteAenderung: "2026-06-14 08:59",
    pos: { x: 56, y: 44 },
  },
];

export const einfahrterlaubnisse = [
  {
    id: "EE-1042",
    nummernschild: "B-SK 1234",
    fahrzeug: "LKW Mercedes Actros",
    firma: "Logistik Nord GmbH",
    fahrer: "Markus Weber",
    sperre: "TS-01",
    gueltigVon: "2026-06-14 06:00",
    gueltigBis: "2026-06-14 18:00",
    status: "aktiv", // aktiv | ausstehend | abgelaufen
  },
  {
    id: "EE-1043",
    nummernschild: "M-AB 9087",
    fahrzeug: "Transporter VW Crafter",
    firma: "Sicherheit24 AG",
    fahrer: "Anna Schulz",
    sperre: "TS-02",
    gueltigVon: "2026-06-14 07:30",
    gueltigBis: "2026-06-14 12:00",
    status: "aktiv",
  },
  {
    id: "EE-1044",
    nummernschild: "HH-XY 4521",
    fahrzeug: "PKW BMW 5er",
    firma: "Verwaltung intern",
    fahrer: "Dr. Peter Klein",
    sperre: "TS-05",
    gueltigVon: "2026-06-14 09:00",
    gueltigBis: "2026-06-14 17:00",
    status: "ausstehend",
  },
  {
    id: "EE-1039",
    nummernschild: "K-DE 7788",
    fahrzeug: "LKW MAN TGX",
    firma: "BauExpress KG",
    fahrer: "Sven Fischer",
    sperre: "TS-03",
    gueltigVon: "2026-06-13 06:00",
    gueltigBis: "2026-06-13 20:00",
    status: "abgelaufen",
  },
  {
    id: "EE-1045",
    nummernschild: "F-GH 3312",
    fahrzeug: "Transporter Ford Transit",
    firma: "CleanService GmbH",
    fahrer: "Julia Braun",
    sperre: "TS-02",
    gueltigVon: "2026-06-14 05:00",
    gueltigBis: "2026-06-14 11:00",
    status: "aktiv",
  },
  {
    id: "EE-1046",
    nummernschild: "S-IJ 5566",
    fahrzeug: "PKW Audi A6",
    firma: "Consulting Partner",
    fahrer: "Thomas Meyer",
    sperre: "TS-01",
    gueltigVon: "2026-06-14 10:00",
    gueltigBis: "2026-06-14 15:00",
    status: "ausstehend",
  },
];

export const ereignisse = [
  { zeit: "08:59", text: "TS-05 geschlossen (bemannt)", typ: "geschlossen" },
  { zeit: "08:47", text: "TS-02 geöffnet für EE-1043", typ: "offen" },
  { zeit: "08:12", text: "TS-01 geschlossen nach Durchfahrt", typ: "geschlossen" },
  { zeit: "07:55", text: "TS-03 auf unbemannt umgestellt", typ: "info" },
  { zeit: "06:30", text: "TS-04 geöffnet (unbemannt)", typ: "offen" },
];

export function getKpis() {
  return {
    offen: sperren.filter((s) => s.status === "offen").length,
    geschlossen: sperren.filter((s) => s.status === "geschlossen").length,
    bemannt: sperren.filter((s) => s.besetzung === "bemannt").length,
    unbemannt: sperren.filter((s) => s.besetzung === "unbemannt").length,
    aktivePermits: einfahrterlaubnisse.filter((e) => e.status === "aktiv").length,
  };
}
